import React from 'react';
import { Input, Modal, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { getElectronicDocumentTitle } from './billDetailHelpers';

const { Text } = Typography;

interface BillDetailEmailModalProps {
  visible: boolean;
  documentType?: string;
  electronicInvoiceNumber?: string | null;
  emailTarget: string;
  onChangeEmailTarget: (email: string) => void;
  onSendEmail: () => void;
  onClose: () => void;
  sendingEmail: boolean;
}

export const BillDetailEmailModal: React.FC<BillDetailEmailModalProps> = ({
  visible,
  documentType,
  electronicInvoiceNumber,
  emailTarget,
  onChangeEmailTarget,
  onSendEmail,
  onClose,
  sendingEmail
}) => {
  const docTitle = getElectronicDocumentTitle(documentType);

  return (
    <Modal
      title={`Reenviar ${docTitle} por Correo`}
      open={visible}
      onCancel={onClose}
      onOk={onSendEmail}
      confirmLoading={sendingEmail}
      okText={`Enviar ${docTitle}`}
      cancelText="Cancelar"
    >
      <div style={{ marginBottom: 12 }}>
        <Text>
          Ingrese el correo electrónico al cual desea enviar la representación gráfica y XML de{' '}
          {docTitle.toLowerCase()} <strong>{electronicInvoiceNumber}</strong>:
        </Text>
      </div>
      <Input 
        prefix={<MailOutlined />} 
        placeholder="correo@ejemplo.com (Opcional si se registró previamente)" 
        value={emailTarget}
        onChange={(e) => onChangeEmailTarget(e.target.value)}
      />
    </Modal>
  );
};
